var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  _vm.$style.cursor,
  _vm.isHover ? _vm.$style.hover : null,
  _vm.$route.name === 'project' ? _vm.$style.dark : null,
  _vm.isMenuOpen ? _vm.$style.light : null ]})}
var staticRenderFns = []

export { render, staticRenderFns }